/* eslint-disable react/prop-types */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';

const ProductInfo = ({ product }) => {
  if (!product) {
    return null;
  }

  const image = product?.media?.images?.find(
    (img) => img.type === 'IMAGE' && img.subType === 'PRIMARY'
  );

  return (
    <div className="sui-flex sui-flex-row">
      <img
        src={image?.url.replace('<SIZE>', '145')}
        alt={product?.identifiers?.productLabel}
        className="sui-aspect-square sui-max-w-[20%] sm:sui-max-w-[30%]"
        width="145px"
        height="145px"
      />
      <div className="sui-pl-6 sui-text-xl">
        <strong>{product?.identifiers?.brandName}&nbsp;</strong>{product?.identifiers?.productLabel}
      </div>
    </div>
  );
};

ProductInfo.propTypes = {};

ProductInfo.displayName = 'ProductInfo';

export { ProductInfo };